import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import Input from '../../../../components/elements/input/Input';
import {
  createMedication,
  updateMedication,
} from '../../api/medicationsApi';

const MedicationModal = ({ isOpen, onClose, onSaved, medication }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const isEdit = Boolean(medication?._id);

  useEffect(() => {
    if (!isOpen) return;
    setName(medication?.name || '');
    setLoading(false);
    setDone(false);
    setError('');
    setSuccessMessage('');
  }, [isOpen, medication]);

  const handleOk = useCallback(async () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      setError('Unesite naziv leka.');
      return;
    }

    const payload = {
      name: trimmedName,
    };

    setLoading(true);
    setError('');
    setSuccessMessage('');

    const response = isEdit
      ? await updateMedication(medication._id, payload)
      : await createMedication(payload);

    if (!response.ok) {
      setError(response.message);
      setLoading(false);
      return;
    }

    setSuccessMessage(
      response.message || (isEdit ? 'Lek azuriran.' : 'Lek kreiran.')
    );
    setDone(true);
    onSaved?.();

    setTimeout(() => {
      setDone(false);
      onClose();
    }, 900);

    setLoading(false);
  }, [isEdit, medication?._id, name, onClose, onSaved]);

  const handleCancel = () => {
    setName(medication?.name || '');
    setLoading(false);
    setDone(false);
    setError('');
    setSuccessMessage('');
    onClose();
  };

  return (
    <Modal
      className="create_user_modal"
      title={isEdit ? 'Azuriraj lek' : 'Dodaj lek'}
      open={isOpen}
      onCancel={handleCancel}
      footer={[
        <Button
          key="save"
          type="primary"
          onClick={handleOk}
          disabled={loading || done}
          style={{ width: '150px' }}
        >
          {loading ? (
            <img
              src="/assets/icons/add.svg"
              alt="Učitavanje"
              className="animate-spin"
            />
          ) : done ? (
            <img
              src="/assets/icons/check.svg"
              alt="Done"
              className="check-icon"
            />
          ) : isEdit ? (
            'Azuriraj'
          ) : (
            'Dodaj lek'
          )}
        </Button>,
      ]}
    >
      <div className="create_user_modal_form" autoComplete="off">
        <Input
          required
          label="Naziv leka"
          id="name"
          name="name"
          placeholder="Naziv leka"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        {successMessage && (
          <Alert
            title={successMessage}
            type="success"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        {error && (
          <Alert
            title={error}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
      </div>
    </Modal>
  );
};

MedicationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func,
  medication: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
  }),
};

export default MedicationModal;
